import React from 'react'

import * as Parts from './Modal.parts'

type ModalProps = React.ComponentPropsWithoutRef<typeof Parts.Root> & {}

export const Modal: React.FC<ModalProps> = (props) => {
    return <Parts.Root {...props} />
}
